import { render, staticRenderFns } from "./polls.vue?vue&type=template&id=ee5c01c6&"
import script from "./polls.vue?vue&type=script&lang=js&"
export * from "./polls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports